import { BaseItem } from './common';
import { Language } from './previsit/language';

export interface FindAllOptions {
  q?: string;
  organizationIds?: string[];
}

export interface LocalizationValues {
  title: string;
  content: string;
  action: string;
}

export type RecommendationTemplateLocalizationMap = Partial<{
  [language in Language]: LocalizationValues;
}> & {
  [Language.En]: LocalizationValues;
};

export interface BaseRecommendationTemplate {
  organizationId: string;
  internalName: string;
  localizations: RecommendationTemplateLocalizationMap;
}

export interface RecommendationTemplatePopulated
  extends RecommendationTemplate {
  uniqueName: string;
}

export type UpdateValues = Partial<BaseRecommendationTemplate>;
export type CreateValues = BaseRecommendationTemplate;
export interface RecommendationTemplate
  extends BaseItem,
    BaseRecommendationTemplate {}
